export default __webpack_public_path__ + "static/media/sigfox-logo-vector.62bbbe08.png";